import React from 'react'
import {HiArrowNarrowRight} from 'react-icons/hi'
import {Link} from 'react-scroll'

const Home = () => {
	return (
		<div name='home' className='w-full h-screen bg-[#0a192f]'>
			{/* Container */}
			<div className='max-w-[1000px] mx-auto  h-full flex flex-col justify-center px-8 '>
				<p className='text-pink-600'>HI ,My name is</p>
				<h1 className='text-4xl  sm:text-7xl font-bold text-[#ccd6f6]'>
					Shakib
				</h1>
				<h2 className='text-4xl sm:text-5xl font-bold text-[#8892b0]'>
					I am a <span className='italic'>Frontend</span> Developer
				</h2>
				<p className='text-[#8892b0] py-4 max-w-[700px]'>
					I’m a fronted developer specializing in building (and occasionally
					designing) exceptional digital experiences. Currently, I’m focused on
					building responsive full-stack web applications.
				</p>
				<div>
					<Link to='work' smooth={true} duration={500}>
						<button className='group text-white border-2 px-4 py-3 flex items-center my-2 hover:bg-pink-600 hover:border-pink-800'>
							View Work
							<span className='group-hover:rotate-90 duration-300'>
								<HiArrowNarrowRight className='ml-3' />
							</span>
						</button>
					</Link>
				</div>
			</div>
		</div>
	)
}

export default Home
